import React, { useMemo } from 'react';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import VenueLiveStreamAttendees from './VenueLiveStreamAttendees';
import VenueLiveStreamCancelButton from './VenueLiveStreamCancelButton';
import VenueLiveStreamSessionVideoPanel from './VenueLiveStreamSessionVideoPanel';
import WebLink from '../../../components/WebLink/WebLink';

const VenueLiveStreamSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <WebLink
                path={`/venues/live-stream/${data.id}`}
            />

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Booking Details"}
                    actions={(
                        <VenueLiveStreamCancelButton session={data} />
                    )}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'Booked By',
                                key: 'owner',
                                format: 'ModelLink'
                            },
                            {
                                label: "Court",
                                key: "court",
                                format: 'ModelLink'
                            },
                            {
                                label: "Host",
                                key: 'host',
                                format: 'ModelLink'
                            },
                            {
                                label: "Order",
                                key: "order",
                                format: 'ModelLink'
                            }
                        ]}
                        columnB={[
                            {
                                label: "Date",
                                key: "date",
                                format: 'date'
                            },
                            {
                                label: "Start Time",
                                key: "startTime",
                            },
                            {
                                label: "Duration",
                                key: "duration",
                                format: "number",
                                suffix: " Hour(s)"
                            },
                            {
                                label: "Status",
                                key: "status",
                                format: "titleCase"
                            }
                        ]}
                        columnC={[
                            {
                                label: "Created",
                                key: "created",
                                format: 'OnAndBy'
                            },
                            {
                                label: "Share Code",
                                key: "shareCode",
                            }
                        ]}
                    />

                </Panel>

                {data.attendees && data.attendees.length > 0 &&
                    <>

                        <Space />

                        <Panel
                            heading={"Attendees"}
                        >

                            <VenueLiveStreamAttendees data={data.attendees} />

                        </Panel>

                    </>
                }

            </Col>

            <Col className={'side'}>

                <VenueLiveStreamSessionVideoPanel stream={data} />

                <Space />

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default VenueLiveStreamSingleView;
